<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('general.subscriptions')" :href="$route('subscriptions')"/>

            <!-- RIGHT -->
            <template v-slot:right>
                <ToolbarLink v-if="Permission.CREATE_SUBSCRIPTION_COUPONS"
                             :href="$route('subscriptions.coupons.create')">
                    <i class="fas fa-plus-square mr-1"/>
                    {{ __('actions.create_thing', {thing: __('general.coupon')}) }}
                </ToolbarLink>
            </template>
        </Toolbar>

        <Card>
            <template v-slot:title>{{ __('general.coupons') }}</template>
            <template v-slot:description>
                {{ __('actions.manage_thing', {thing: __('general.coupons')}) }}
            </template>

            <!-- COUPONS -->
            <div class="table-responsive">
                <table class="table table-vertical-center table-hover">
                    <thead>
                    <tr>
                        <th>{{ __('general.designation') }}</th>
                        <th class="text-center">{{ __('general.value') }}/{{ __('general.type') }}</th>
                        <th class="text-center">{{ __('general.months') }}</th>
                        <th class="text-center">Verbl. Anwendungen</th>
                        <th class="text-center">{{ __('general.expiry_date') }}</th>
                        <th class="text-center">{{ __('general.usages') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="coupon in paginatedCoupons.data">
                        <td>
                            {{ coupon.name }}
                            <Dot v-if="coupon.is_redeemable" class="ml-1" type="success"
                                 title="Kann eingelöst werden"/>
                            <Dot v-else class="ml-1" type="danger" title="Abgelaufen"/>
                        </td>
                        <td class="text-center font-weight-bold">
                            {{ coupon.value.toFixed(2) }}
                            <i v-if="coupon.type === 'percent'" class="fas fa-percent"/>
                            <i v-if="coupon.type === 'amount'" class="fas fa-euro-sign"/>
                        </td>
                        <td class="text-center">
                            {{ coupon.months_discounted || 'Unbegrenzt' }}
                        </td>
                        <td class="text-center">
                            {{
                                coupon.max_redemptions ? coupon.max_redemptions - coupon.subscriptions_count : 'Unbegrenzt'
                            }}
                        </td>
                        <td class="text-center">
                            {{ coupon.expires_at ? $localDate(coupon.expires_at) : 'Nie' }}
                        </td>
                        <td class="text-center">
                            <Link as="a" :href="$route('subscriptions', {coupon: coupon.slug})">
                                {{ coupon.subscriptions_count }} Abos
                            </Link>
                        </td>
                        <td class="text-right">
                            <div class="btn-group">
                                <!--                                <button v-if="coupon.is_redeemable" class="btn btn-xs btn-danger">-->
                                <!--                                    <i class="fas fa-ban ml-1" />-->
                                <!--                                </button>-->
                                <button v-if="Permission.VIEW_SUBSCRIPTION_COUPONS"
                                        class="btn btn-xs btn-default btn-hover-primary">
                                    <i class="fas fa-info-circle mr-1"/>
                                    {{ __('actions.view_thing', {thing: __('general.details')}) }}
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <!-- PAGINATION -->
            <Pagination class="mt-3"
                        :pagination="paginatedCoupons"
                        :inertia-options="{only: ['paginatedCoupons']}"
                        disable-when-one-page
            />
        </Card>
    </div>
</template>

<script>
import Pagination from "@components/TableComponents/Pagination.vue";
import BackButton from "@components/BackButton.vue";
import { Link } from '@inertiajs/vue2';
import Card from "@components/Cards/Card.vue";
import Dot from "@components/Dot.vue";
import Toolbar from "@components/Toolbar.vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import {PermissionsMixin} from "@js/permissions";

export default {
    components: {ToolbarLink, Toolbar, Dot, Card, BackButton, Pagination, Link},

    mixins: [PermissionsMixin],

    props: {
        paginatedCoupons: Object
    }
}
</script>
